/**
 * ecommate / Wischstar custom theme scripts
 * Keep merchant JS here (or em-*.js feature files), not in Custom Liquid JSON.
 * Cookie reopen (#reopenBanner) is handled by Pandectes (no theme script).
 * Pandectes a11y widget: footer button id="triggerPandectesA11y" (snippets/em-a11y-trigger.liquid).
 */

(function () {
  const BODY_CLASS = 'em-a11y-open';
  const HOST_SEL = 'pandectes-a11y';
  const TRIGGER_ID = 'triggerPandectesA11y';

  let hostObserver = null;
  let shadowObserver = null;
  let pollTimer = null;

  function setOpen(isOpen) {
    document.body.classList.toggle(BODY_CLASS, Boolean(isOpen));
  }

  function dialogLooksOpen(el) {
    if (!el) return false;
    if (el.open === true) return true;
    if (el.getAttribute('aria-hidden') === 'false') return true;
    if (el.getAttribute('aria-modal') === 'true') {
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }
    return el.classList.contains('open') || el.classList.contains('is-open') || el.classList.contains('active');
  }

  function isA11yOpen(host) {
    if (!host) return false;
    if (host.hasAttribute('open')) return true;
    if (host.getAttribute('aria-expanded') === 'true') return true;
    if (host.getAttribute('data-open') === 'true') return true;

    const root = host.shadowRoot;
    if (!root) return false;

    if (root.querySelector('dialog[open], [aria-modal="true"], [data-open="true"], .is-open, .open')) {
      const candidates = root.querySelectorAll('dialog, [role="dialog"], [aria-modal], [data-role="dialog"], .dialog, aside, section');
      for (let i = 0; i < candidates.length; i += 1) {
        if (dialogLooksOpen(candidates[i])) return true;
      }
      // Fallback: any dialog[open] already matched above
      if (root.querySelector('dialog[open]')) return true;
    }

    return false;
  }

  function sync() {
    setOpen(isA11yOpen(document.querySelector(HOST_SEL)));
  }

  function observeShadow(host) {
    if (shadowObserver) {
      shadowObserver.disconnect();
      shadowObserver = null;
    }
    if (!host || !host.shadowRoot) return;

    shadowObserver = new MutationObserver(sync);
    shadowObserver.observe(host.shadowRoot, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['open', 'aria-hidden', 'aria-expanded', 'aria-modal', 'class', 'data-open', 'hidden'],
    });
  }

  function bindHost(host) {
    if (!host) return;
    if (hostObserver) hostObserver.disconnect();

    hostObserver = new MutationObserver(function () {
      observeShadow(host);
      sync();
    });
    hostObserver.observe(host, {
      attributes: true,
      attributeFilter: ['open', 'aria-expanded', 'aria-modal', 'class', 'data-open'],
    });
    observeShadow(host);
    sync();
  }

  function onTriggerClick() {
    // Optimistic open — covers closed shadow roots where we cannot inspect dialog state.
    setOpen(true);
    window.setTimeout(sync, 50);
    window.setTimeout(sync, 250);
    window.setTimeout(sync, 600);
  }

  function init() {
    const host = document.querySelector(HOST_SEL);
    if (host) bindHost(host);

    document.addEventListener(
      'click',
      function (event) {
        const trigger = event.target && event.target.closest && event.target.closest('#' + TRIGGER_ID);
        if (trigger) onTriggerClick();
        window.setTimeout(sync, 100);
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        // Drawer close is usually Escape; clear overlay widgets immediately.
        setOpen(false);
        window.setTimeout(sync, 50);
        window.setTimeout(sync, 250);
      }
    });

    // Host may mount late via app embed.
    const bootObserver = new MutationObserver(function () {
      const next = document.querySelector(HOST_SEL);
      if (next) {
        bindHost(next);
        bootObserver.disconnect();
      }
    });
    bootObserver.observe(document.documentElement, { childList: true, subtree: true });

    // Keep in sync when shadow root is readable.
    pollTimer = window.setInterval(function () {
      const current = document.querySelector(HOST_SEL);
      if (!current) {
        setOpen(false);
        return;
      }
      if (current.shadowRoot) sync();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  const TRUSTED_SHOPS_SELECTOR = [
    '[id*="trustbadge" i]',
    '[id*="minimized-trustbadge" i]',
    '[id*="maximized-trustbadge" i]',
    '[id*="trustbadge-container" i]',
    'iframe[src*="trustedshops"]',
    'iframe[src*="widgets.trustedshops"]',
    'iframe[src*="etrusted"]',
  ].join(',');

  const BODY_CLASS = 'em-scrolling';
  const SCROLL_END_MS = 900;
  let scrollTimer = null;

  function trustedShopsNodes() {
    const nodes = new Set();
    document.querySelectorAll(TRUSTED_SHOPS_SELECTOR).forEach((node) => {
      nodes.add(node);
      const root = node.closest('[id*="trustbadge" i]');
      if (root) nodes.add(root);
    });
    return nodes;
  }

  function setTrustedShopsHidden(hidden) {
    document.body.classList.toggle(BODY_CLASS, hidden);
    trustedShopsNodes().forEach((node) => {
      node.classList.toggle('em-ts-scroll-hidden', hidden);
    });
  }

  function onScrollActivity() {
    setTrustedShopsHidden(true);
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(function () {
      setTrustedShopsHidden(false);
    }, SCROLL_END_MS);
  }

  window.addEventListener('scroll', onScrollActivity, { passive: true, capture: true });
  document.addEventListener('scroll', onScrollActivity, { passive: true, capture: true });
  window.addEventListener('wheel', onScrollActivity, { passive: true });
  window.addEventListener('touchmove', onScrollActivity, { passive: true });

  const widgetObserver = new MutationObserver(function () {
    if (document.body.classList.contains(BODY_CLASS)) {
      trustedShopsNodes().forEach((node) => node.classList.add('em-ts-scroll-hidden'));
    }
  });
  widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  const TAB_SELECTOR = 'tabs-element.mega-menu__nav--tabs button.em-mega-tab[data-collection-url]';
  const MEGA_MENU_SELECTOR = '.mega-menu';
  let keyboardFocus = false;

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Tab') keyboardFocus = true;
    },
    true
  );

  document.addEventListener(
    'mousedown',
    function () {
      keyboardFocus = false;
    },
    true
  );

  function getTabButtons(tabs) {
    return Array.from(tabs.querySelectorAll('button.em-mega-tab[data-collection-url]'));
  }

  function clearMegaMenuFocus(tabs) {
    if (window.theme && window.theme.a11y) {
      window.theme.a11y.removeTrapFocus();
    }

    const active = document.activeElement;
    if (active && tabs.contains(active)) {
      active.blur();
    }
  }

  function switchMegaTab(button) {
    const tabs = button.closest('tabs-element');
    if (!tabs) return;

    const buttons = getTabButtons(tabs);
    const idx = parseInt(button.getAttribute('data-index'), 10);
    if (Number.isNaN(idx)) return;

    const currentIdx = parseInt(
      buttons.find(function (btn) {
        return btn.getAttribute('aria-selected') === 'true';
      })?.getAttribute('data-index') || '-1',
      10
    );
    if (currentIdx === idx) return;

    buttons.forEach(function (btn) {
      const btnIdx = parseInt(btn.getAttribute('data-index'), 10);
      const isSelected = btnIdx === idx;
      const panelId = btn.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;

      if (panel) panel.hidden = !isSelected;

      btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      btn.setAttribute('tabindex', isSelected ? '0' : '-1');
      btn.classList.toggle('button--primary', isSelected);
      btn.classList.toggle('button--secondary', !isSelected);
    });

    clearMegaMenuFocus(tabs);
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      const megaMenu = event.target.closest(MEGA_MENU_SELECTOR);
      if (megaMenu) megaMenu.classList.add('em-mega-pointer-active');

      const button = event.target.closest(TAB_SELECTOR);
      if (button) switchMegaTab(button);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      const megaMenu = event.target.closest(MEGA_MENU_SELECTOR);
      if (!megaMenu) return;
      if (!megaMenu.contains(event.relatedTarget)) {
        megaMenu.classList.remove('em-mega-pointer-active');
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      if (keyboardFocus) return;

      const megaMenu = event.target.closest(MEGA_MENU_SELECTOR);
      if (!megaMenu || !megaMenu.classList.contains('em-mega-pointer-active')) return;

      const focusTarget = event.target.closest('slider-element, .mega-menu__list');
      if (!focusTarget) return;

      focusTarget.blur();
      if (window.theme && window.theme.a11y) {
        window.theme.a11y.removeTrapFocus();
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    const button = event.target.closest(TAB_SELECTOR);
    if (!button) return;
    const url = button.getAttribute('data-collection-url');
    if (url) window.location.href = url;
  });
})();

/**
 * Menu drawer (collections): on open, drill to the current collection URL.
 * Close always resets to root — never keep nested `.active` while hidden.
 */
(function () {
  var DRAWER_ID = 'MenuDrawer';
  var RESTORING = 'em-menu-path-restoring';

  function drawer() {
    return document.getElementById(DRAWER_ID);
  }

  function isCollectionPage() {
    if (document.body.classList.contains('template-product')) return false;
    if (document.body.classList.contains('template-collection')) return true;
    var path = location.pathname.replace(/\/+$/, '') || '/';
    return path.indexOf('/collections/') === 0 && path.indexOf('/products/') === -1;
  }

  function pathOf(href) {
    try {
      return (new URL(href, location.origin).pathname.replace(/\/+$/, '') || '/');
    } catch (e) {
      return '';
    }
  }

  function currentPath() {
    return location.pathname.replace(/\/+$/, '') || '/';
  }

  function parentOf(details) {
    return details.closest('[data-parent]') ||
      (details.parentElement && details.parentElement.closest('[data-parent]'));
  }

  function setOpen(details, open) {
    var summary = details.querySelector(':scope > summary');
    var parent = parentOf(details);
    if (open) {
      details.setAttribute('open', '');
      details.classList.add('active');
      if (parent) parent.classList.add('active');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
        summary.setAttribute('tabindex', '-1');
      }
    } else {
      if (parent) parent.classList.remove('active');
      details.classList.remove('active');
      details.removeAttribute('open');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        summary.removeAttribute('tabindex');
      }
    }
  }

  function clearMotionStyles(root) {
    root.querySelectorAll('.drawer__scrollable > li, .drawer__menu-item, summary').forEach(function (el) {
      el.style.transform = '';
      el.style.opacity = '';
      el.style.transition = '';
    });
  }

  function reset(root) {
    root.querySelectorAll('details[is="menu-details"].active, details[is="menu-details"][open]').forEach(function (d) {
      setOpen(d, false);
    });
    root.querySelectorAll('[data-parent].active').forEach(function (el) {
      el.classList.remove('active');
    });
    clearMotionStyles(root);
  }

  function hasContent(details) {
    var host =
      details.querySelector('[id^="DrawerSubMenu"]') ||
      details.querySelector('.drawer__scrollable');
    return Boolean(host && host.querySelector('li, a, details, .drawer__menu-item'));
  }

  function loadApi(details) {
    if (hasContent(details)) return Promise.resolve(true);
    var summary = details.querySelector(':scope > summary');
    var api = summary && summary.querySelector('api-button');
    if (!api || typeof api.init !== 'function') return Promise.resolve(hasContent(details));

    try {
      if (api.initialized && !hasContent(details)) api.initialized = false;
      api.init();
    } catch (e) { /* ignore */ }

    return new Promise(function (resolve) {
      var start = Date.now();
      (function poll() {
        if (hasContent(details)) return resolve(true);
        if (Date.now() - start > 2500) return resolve(false);
        setTimeout(poll, 50);
      })();
    });
  }

  function findLink(root, path) {
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (pathOf(links[i].href) === path) return links[i];
    }
    return null;
  }

  function rootDetails(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('details[is="menu-details"]'),
      function (d) {
        return !d.parentElement.closest('details[is="menu-details"]');
      }
    );
  }

  async function openToCurrentCollection(root) {
    if (!root || root.__emRestoring || !isCollectionPage()) return;
    var path = currentPath();
    root.__emRestoring = true;
    root.classList.add(RESTORING);

    try {
      reset(root);

      var roots = rootDetails(root);
      for (var i = 0; i < roots.length; i++) {
        var branch = roots[i];
        if (!(await loadApi(branch))) continue;

        var link = findLink(branch, path);
        if (!link) continue;

        // Open every menu-details from this branch root down to the link.
        var chain = [];
        var el = link.closest('details[is="menu-details"]');
        while (el && branch.contains(el)) {
          chain.unshift(el);
          el = el.parentElement && el.parentElement.closest('details[is="menu-details"]');
        }

        for (var c = 0; c < chain.length; c++) {
          if (!(await loadApi(chain[c]))) break;
          setOpen(chain[c], true);
          if (!hasContent(chain[c])) {
            setOpen(chain[c], false);
            break;
          }
        }
        clearMotionStyles(root);
        return;
      }
    } finally {
      root.__emRestoring = false;
      requestAnimationFrame(function () {
        root.classList.remove(RESTORING);
      });
    }
  }

  function patchMenuDrawer() {
    var Ctor = customElements.get('menu-drawer');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__emPathPatched) return;
    Ctor.prototype.__emPathPatched = true;

    var DrawerElement = customElements.get('drawer-element');
    var prevShow = Ctor.prototype.beforeShow;
    var prevHide = Ctor.prototype.beforeHide;

    Ctor.prototype.beforeHide = function () {
      reset(this);
      // Avoid MenuDrawer's delayed close — it races with a quick reopen.
      if (isCollectionPage() && DrawerElement && DrawerElement.prototype.beforeHide) {
        DrawerElement.prototype.beforeHide.call(this);
        return;
      }
      if (typeof prevHide === 'function') prevHide.call(this);
    };

    Ctor.prototype.beforeShow = function () {
      this._menuItems = null;
      if (!isCollectionPage()) reset(this);
      if (typeof prevShow === 'function') prevShow.call(this);
    };
  }

  function init() {
    var el = drawer();
    if (el) {
      el.classList.remove(RESTORING);
      reset(el);
    }

    if (customElements.whenDefined) {
      customElements.whenDefined('menu-drawer').then(patchMenuDrawer);
    } else {
      patchMenuDrawer();
    }

    document.addEventListener('drawer:afterShow', function (event) {
      if (event.target && event.target.id === DRAWER_ID) {
        openToCurrentCollection(event.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Collection subcollections custom dropdown (replaces native <select is="sub-collections">).
 * Blog tag filter still uses the core select CE — leave that alone.
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('em-subcollections')) return;

  class EmSubcollections extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.em-subcollections-dropdown__trigger');
      this.listbox = this.querySelector('.em-subcollections-dropdown__listbox');
      if (!this.trigger || !this.listbox) return;

      this._onTriggerClick = this.onTriggerClick.bind(this);
      this._onDocumentClick = this.onDocumentClick.bind(this);
      this._onKeyDown = this.onKeyDown.bind(this);

      this.trigger.addEventListener('click', this._onTriggerClick);
      document.addEventListener('click', this._onDocumentClick);
      this.addEventListener('keydown', this._onKeyDown);
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this._onTriggerClick);
      document.removeEventListener('click', this._onDocumentClick);
      this.removeEventListener('keydown', this._onKeyDown);
    }

    get open() {
      return this.hasAttribute('open');
    }

    show() {
      this.setAttribute('open', '');
      this.listbox.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    hide() {
      this.removeAttribute('open');
      this.listbox.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    toggle() {
      if (this.open) this.hide();
      else this.show();
    }

    onTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }

    onDocumentClick(event) {
      if (!this.open) return;
      if (this.contains(event.target)) return;
      this.hide();
    }

    onKeyDown(event) {
      if (event.key === 'Escape' && this.open) {
        event.preventDefault();
        this.hide();
        this.trigger.focus();
        return;
      }

      if (!this.open) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          if (event.target === this.trigger) {
            event.preventDefault();
            this.show();
            const first = this.listbox.querySelector('a:not(.is-selected)');
            if (first) first.focus();
          }
        }
        return;
      }

      const options = Array.from(this.listbox.querySelectorAll('a:not(.is-selected)'));
      if (!options.length) return;

      const index = options.indexOf(document.activeElement);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        const next = options[Math.min(index + 1, options.length - 1)] || options[0];
        next.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        const prev = options[Math.max(index - 1, 0)] || options[options.length - 1];
        prev.focus();
      } else if (event.key === 'Home') {
        event.preventDefault();
        options[0].focus();
      } else if (event.key === 'End') {
        event.preventDefault();
        options[options.length - 1].focus();
      }
    }
  }

  customElements.define('em-subcollections', EmSubcollections);
})();


/* Overlay cursor is optional — skip if mouse-cursor is not rendered */
(function () {
  if (!window.customElements || !customElements.whenDefined) return;
  customElements.whenDefined('overlay-element').then(function () {
    var Ctor = customElements.get('overlay-element');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__emCursorGuarded) return;
    ['onMouseMove', 'onMouseLeave', 'onMouseDown', 'onMouseUp'].forEach(function (method) {
      var original = Ctor.prototype[method];
      if (typeof original !== 'function') return;
      Ctor.prototype[method] = function () {
        if (!this.cursor) return;
        return original.apply(this, arguments);
      };
    });
    Ctor.prototype.__emCursorGuarded = true;
  });
})();
